export const ACTIONS = {
  OPEN_SALES_REP: "openSalesRep",
  TOGGLE_CART_SELECTION: "toggleCartSelection",
  OPEN_PAYMENT: "openPayment",
  SHOW_ORDER_HISTORY: "showOrderHistory",
  SHOW_PARKED_BILLS: "showParkedBills",
  QTY_UPDATE: "qtyUpdate",
  PARK_BILL: "parkBill",
  DISCARD_CART: "discardCart",
  CLOSE_ACTIVE: "closeActive",
  CART_MOVE_UP: "cartMoveUp",
  CART_MOVE_DOWN: "cartMoveDown",
  INCREASE_QTY: "increaseQty",
  DECREASE_QTY: "decreaseQty",
  DELETE_PRODUCT: "deleteProduct",
  OPEN_SALES_RETURN: "openSalesReturn",

  HELP_OVERLAY: "helpOverlay",
  ZONE_SEARCH: "zoneSearch",
  ZONE_CART: "zoneCart",
  ZONE_CUSTOMER: "zoneCustomer",
  ZONE_MENU: "zoneMenu",
  ZONE_PAYMENT: "zonePayment",
  QUICK_CASH: "quickCash",
  PRODUCT_SYNC: "productSync",

  CUSTOMER_SEARCH: "customerSearch",
  MANUAL_DISCOUNT: "manualDiscount",
  GIFT_CARD: "giftCard",
  CASH_MANAGEMENT: "cashManagement",
  ITEM_NOTES: "itemNotes",
  ADDITIONAL_CHARGES: "additionalCharges",
  PRINT_RECEIPT: "printReceipt",
  CUSTOMER_WALLET: "customerWallet",
  COMPLETE_PAYMENT: "completePayment",

  SEND_KOT: "sendKOT",
  GUEST_COUNT: "guestCount",
  TRANSFER_TABLE: "transferTable",
  MERGE_TABLES: "mergeTables",
  FULFILLMENT_DI: "fulfillmentDI",
  FULFILLMENT_DE: "fulfillmentDE",
  FULFILLMENT_TA: "fulfillmentTA",
  SWITCH_SECTION: "switchSection",
};

export const CATEGORIES = {
  ZONE_NAV: "zone-navigation",
  ACTION: "action",
  CART_NAV: "cart-navigation",
  RESTAURANT_ACTION: "restaurant-action",
};

export const SCOPES = {
  BOTH: "both",
  SUPERMARKET: "supermarket",
  RESTAURANT: "restaurant",
};

export const CONDITIONS = {
  ITEM_SELECTED: "itemSelected",
  CART_HAS_ITEMS: "cartHasItems",
  PAYMENT_IN_PROGRESS: "paymentInProgress",
  CUSTOMER_SELECTED: "customerSelected",
  LAST_ORDER_EXISTS: "lastOrderExists",
  SALES_REP_CONFIG: "salesRepConfig",
  SALES_RETURN_CONFIG: "salesReturnConfig",
  TABLE_SELECTED: "tableSelected",
  TABLE_WITH_ORDER: "tableWithOrder",
  ORDER_HAS_UNSENT: "orderHasUnsentItems",
  SIDEBAR_FOCUSED_NO_INPUT: "sidebarFocusedNoInput",
  TABLE_VIEW: "tableView",
  ITEM_QTY_GT_1: "itemQtyGreaterThan1",
  NOT_DI_SALE_TYPE: "notDISaleType",
  NO_MODAL_OPEN: "noModalOpen",
};

const shortcuts = [
  // ── Existing shortcuts (always active, no feature flag) ──────────────
  {
    id: "alt-s-sales-rep",
    label: "Alt+S",
    match: { keyCode: 83, alt: true },
    action: ACTIONS.OPEN_SALES_REP,
    category: CATEGORIES.ACTION,
    scope: SCOPES.BOTH,
    conditions: [CONDITIONS.SALES_REP_CONFIG],
    description: "Open Sales Rep Modal",
    gated: false,
    phase: 0,
  },
  {
    id: "alt-c-cart-select",
    label: "Alt+C",
    match: { keyCode: 67, alt: true },
    action: ACTIONS.TOGGLE_CART_SELECTION,
    category: CATEGORIES.CART_NAV,
    scope: SCOPES.BOTH,
    conditions: null,
    description: "Toggle cart row selection",
    gated: false,
    phase: 0,
  },
  {
    id: "alt-p-payment",
    label: "Alt+P",
    match: { keyCode: 80, alt: true },
    action: ACTIONS.OPEN_PAYMENT,
    category: CATEGORIES.ACTION,
    scope: SCOPES.BOTH,
    conditions: null,
    description: "Open Payment Modal",
    gated: false,
    phase: 0,
  },
  {
    id: "alt-o-orders",
    label: "Alt+O",
    match: { keyCode: 79, alt: true },
    action: ACTIONS.SHOW_ORDER_HISTORY,
    category: CATEGORIES.ACTION,
    scope: SCOPES.BOTH,
    conditions: null,
    description: "Order History",
    gated: false,
    phase: 0,
  },
  {
    id: "alt-b-parked",
    label: "Alt+B",
    match: { keyCode: 66, alt: true },
    action: ACTIONS.SHOW_PARKED_BILLS,
    category: CATEGORIES.ACTION,
    scope: SCOPES.BOTH,
    conditions: null,
    description: "Parked Bills",
    gated: false,
    phase: 0,
  },
  {
    id: "alt-i-qty",
    label: "Alt+I",
    match: { keyCode: 73, alt: true },
    action: ACTIONS.QTY_UPDATE,
    category: CATEGORIES.CART_NAV,
    scope: SCOPES.BOTH,
    conditions: [CONDITIONS.ITEM_SELECTED],
    description: "Qty Update (selected item)",
    gated: false,
    phase: 0,
  },
  {
    id: "alt-l-park",
    label: "Alt+L",
    match: { keyCode: 76, alt: true },
    action: ACTIONS.PARK_BILL,
    category: CATEGORIES.ACTION,
    scope: SCOPES.BOTH,
    conditions: null,
    description: "Park Bill",
    gated: false,
    phase: 0,
  },
  {
    id: "alt-h-discard",
    label: "Alt+H",
    match: { keyCode: 72, alt: true },
    action: ACTIONS.DISCARD_CART,
    category: CATEGORIES.ACTION,
    scope: SCOPES.BOTH,
    conditions: null,
    description: "Discard / Clear Cart",
    gated: false,
    phase: 0,
  },
  {
    id: "escape-close",
    label: "Esc",
    match: { keyCode: 27 },
    action: ACTIONS.CLOSE_ACTIVE,
    category: CATEGORIES.ACTION,
    scope: SCOPES.BOTH,
    conditions: null,
    description: "Close / Back",
    gated: false,
    phase: 0,
  },
  {
    id: "arrow-up",
    label: "Arrow Up",
    match: { keyCode: 38 },
    action: ACTIONS.CART_MOVE_UP,
    category: CATEGORIES.CART_NAV,
    scope: SCOPES.BOTH,
    conditions: null,
    description: "Move cart selection up",
    gated: false,
    phase: 0,
  },
  {
    id: "arrow-down",
    label: "Arrow Down",
    match: { keyCode: 40 },
    action: ACTIONS.CART_MOVE_DOWN,
    category: CATEGORIES.CART_NAV,
    scope: SCOPES.BOTH,
    conditions: null,
    description: "Move cart selection down",
    gated: false,
    phase: 0,
  },
  {
    id: "plus-qty",
    label: "+",
    match: { keyCode: [187, 107] },
    action: ACTIONS.INCREASE_QTY,
    category: CATEGORIES.CART_NAV,
    scope: SCOPES.BOTH,
    conditions: [CONDITIONS.ITEM_SELECTED, CONDITIONS.NO_MODAL_OPEN, CONDITIONS.NOT_DI_SALE_TYPE],
    description: "Increase item qty",
    gated: false,
    phase: 0,
  },
  {
    id: "minus-qty",
    label: "−",
    match: { keyCode: [109, 189] },
    action: ACTIONS.DECREASE_QTY,
    category: CATEGORIES.CART_NAV,
    scope: SCOPES.BOTH,
    conditions: [CONDITIONS.ITEM_SELECTED, CONDITIONS.NO_MODAL_OPEN, CONDITIONS.NOT_DI_SALE_TYPE, CONDITIONS.ITEM_QTY_GT_1],
    description: "Decrease item qty",
    gated: false,
    phase: 0,
  },
  {
    id: "delete-product",
    label: "Delete",
    match: { keyCode: 46 },
    action: ACTIONS.DELETE_PRODUCT,
    category: CATEGORIES.CART_NAV,
    scope: SCOPES.BOTH,
    conditions: [CONDITIONS.ITEM_SELECTED],
    description: "Remove selected item",
    gated: false,
    phase: 0,
  },
  {
    id: "alt-r-return",
    label: "Alt+R",
    match: { keyCode: 82, alt: true },
    action: ACTIONS.OPEN_SALES_RETURN,
    category: CATEGORIES.ACTION,
    scope: SCOPES.BOTH,
    conditions: [CONDITIONS.SALES_RETURN_CONFIG],
    description: "Sales Return",
    gated: false,
    phase: 0,
  },

  // ── New: Zone navigation (F-keys) — Phase 1, gated ──────────────────
  {
    id: "f1-help",
    label: "F1",
    match: { keyCode: 112 },
    action: ACTIONS.HELP_OVERLAY,
    category: CATEGORIES.ZONE_NAV,
    scope: SCOPES.BOTH,
    conditions: null,
    description: "Help Overlay",
    gated: true,
    phase: 1,
  },
  {
    id: "f2-search",
    label: "F2",
    match: { keyCode: 113 },
    action: ACTIONS.ZONE_SEARCH,
    category: CATEGORIES.ZONE_NAV,
    scope: SCOPES.BOTH,
    conditions: null,
    description: "Focus Search",
    gated: true,
    phase: 1,
  },
  {
    id: "f3-cart-tables",
    label: "F3",
    match: { keyCode: 114 },
    action: ACTIONS.ZONE_CART,
    category: CATEGORIES.ZONE_NAV,
    scope: SCOPES.BOTH,
    conditions: null,
    description: "Focus Cart / Tables",
    gated: true,
    phase: 1,
  },
  {
    id: "f4-customer-products",
    label: "F4",
    match: { keyCode: 115 },
    action: ACTIONS.ZONE_CUSTOMER,
    category: CATEGORIES.ZONE_NAV,
    scope: SCOPES.BOTH,
    conditions: null,
    description: "Focus Customer / Products",
    gated: true,
    phase: 1,
  },
  {
    id: "f5-menu-order",
    label: "F5",
    match: { keyCode: 116 },
    action: ACTIONS.ZONE_MENU,
    category: CATEGORIES.ZONE_NAV,
    scope: SCOPES.BOTH,
    conditions: null,
    description: "Focus Menu / Order Panel",
    gated: true,
    phase: 1,
  },
  {
    id: "f6-payment-actions",
    label: "F6",
    match: { keyCode: 117 },
    action: ACTIONS.ZONE_PAYMENT,
    category: CATEGORIES.ZONE_NAV,
    scope: SCOPES.BOTH,
    conditions: null,
    description: "Focus Payment / Actions",
    gated: true,
    phase: 1,
  },
  {
    id: "f7-quick-cash",
    label: "F7",
    match: { keyCode: 118 },
    action: ACTIONS.QUICK_CASH,
    category: CATEGORIES.ACTION,
    scope: SCOPES.BOTH,
    conditions: [CONDITIONS.CART_HAS_ITEMS],
    description: "Quick Cash (exact amount)",
    gated: true,
    phase: 3,
  },
  {
    id: "f8-sync",
    label: "F8",
    match: { keyCode: 119 },
    action: ACTIONS.PRODUCT_SYNC,
    category: CATEGORIES.ACTION,
    scope: SCOPES.BOTH,
    conditions: null,
    description: "Product Sync",
    gated: true,
    phase: 3,
  },

  // ── New: Action shortcuts (Alt+key, shared) — Phase 3, gated ────────
  {
    id: "alt-u-customer",
    label: "Alt+U",
    match: { keyCode: 85, alt: true },
    action: ACTIONS.CUSTOMER_SEARCH,
    category: CATEGORIES.ACTION,
    scope: SCOPES.BOTH,
    conditions: null,
    description: "Customer Search / Add",
    gated: true,
    phase: 3,
  },
  {
    id: "alt-d-discount",
    label: "Alt+D",
    match: { keyCode: 68, alt: true },
    action: ACTIONS.MANUAL_DISCOUNT,
    category: CATEGORIES.ACTION,
    scope: SCOPES.BOTH,
    conditions: [CONDITIONS.CART_HAS_ITEMS],
    description: "Manual Discount",
    gated: true,
    phase: 3,
  },
  {
    id: "alt-g-gift",
    label: "Alt+G",
    match: { keyCode: 71, alt: true },
    action: ACTIONS.GIFT_CARD,
    category: CATEGORIES.ACTION,
    scope: SCOPES.BOTH,
    conditions: null,
    description: "Gift Card",
    gated: true,
    phase: 3,
  },
  {
    id: "alt-m-cash-mgmt",
    label: "Alt+M",
    match: { keyCode: 77, alt: true },
    action: ACTIONS.CASH_MANAGEMENT,
    category: CATEGORIES.ACTION,
    scope: SCOPES.BOTH,
    conditions: null,
    description: "Cash Management",
    gated: true,
    phase: 3,
  },
  {
    id: "alt-n-notes",
    label: "Alt+N",
    match: { keyCode: 78, alt: true },
    action: ACTIONS.ITEM_NOTES,
    category: CATEGORIES.CART_NAV,
    scope: SCOPES.BOTH,
    conditions: [CONDITIONS.ITEM_SELECTED],
    description: "Notes on selected item",
    gated: true,
    phase: 3,
  },
  {
    id: "alt-e-charges",
    label: "Alt+E",
    match: { keyCode: 69, alt: true },
    action: ACTIONS.ADDITIONAL_CHARGES,
    category: CATEGORIES.ACTION,
    scope: SCOPES.BOTH,
    conditions: [CONDITIONS.CART_HAS_ITEMS],
    description: "Additional Charges",
    gated: true,
    phase: 3,
  },
  {
    id: "alt-t-receipt",
    label: "Alt+T",
    match: { keyCode: 84, alt: true },
    action: ACTIONS.PRINT_RECEIPT,
    category: CATEGORIES.ACTION,
    scope: SCOPES.BOTH,
    conditions: [CONDITIONS.LAST_ORDER_EXISTS],
    description: "Print Last Receipt",
    gated: true,
    phase: 3,
  },
  {
    id: "alt-w-wallet",
    label: "Alt+W",
    match: { keyCode: 87, alt: true },
    action: ACTIONS.CUSTOMER_WALLET,
    category: CATEGORIES.ACTION,
    scope: SCOPES.BOTH,
    conditions: [CONDITIONS.CUSTOMER_SELECTED],
    description: "Customer Wallet",
    gated: true,
    phase: 3,
  },
  {
    id: "alt-f-finish",
    label: "Alt+F",
    match: { keyCode: 70, alt: true },
    action: ACTIONS.COMPLETE_PAYMENT,
    category: CATEGORIES.ACTION,
    scope: SCOPES.BOTH,
    conditions: [CONDITIONS.PAYMENT_IN_PROGRESS],
    description: "Complete Payment (Finish)",
    gated: true,
    phase: 3,
  },

  // ── New: Restaurant-only shortcuts — Phase 3, gated ─────────────────
  {
    id: "alt-k-kot",
    label: "Alt+K",
    match: { keyCode: 75, alt: true },
    action: ACTIONS.SEND_KOT,
    category: CATEGORIES.RESTAURANT_ACTION,
    scope: SCOPES.RESTAURANT,
    conditions: [CONDITIONS.ORDER_HAS_UNSENT],
    description: "Send KOT",
    gated: true,
    phase: 3,
  },
  {
    id: "alt-q-guest",
    label: "Alt+Q",
    match: { keyCode: 81, alt: true },
    action: ACTIONS.GUEST_COUNT,
    category: CATEGORIES.RESTAURANT_ACTION,
    scope: SCOPES.RESTAURANT,
    conditions: [CONDITIONS.TABLE_SELECTED],
    description: "Guest Count",
    gated: true,
    phase: 3,
  },
  {
    id: "alt-x-transfer",
    label: "Alt+X",
    match: { keyCode: 88, alt: true },
    action: ACTIONS.TRANSFER_TABLE,
    category: CATEGORIES.RESTAURANT_ACTION,
    scope: SCOPES.RESTAURANT,
    conditions: [CONDITIONS.TABLE_WITH_ORDER],
    description: "Transfer Table",
    gated: true,
    phase: 3,
  },
  {
    id: "alt-j-merge",
    label: "Alt+J",
    match: { keyCode: 74, alt: true },
    action: ACTIONS.MERGE_TABLES,
    category: CATEGORIES.RESTAURANT_ACTION,
    scope: SCOPES.RESTAURANT,
    conditions: [CONDITIONS.TABLE_SELECTED],
    description: "Merge Tables",
    gated: true,
    phase: 3,
  },
  {
    id: "key-0-di",
    label: "0",
    match: { keyCode: 48 },
    action: ACTIONS.FULFILLMENT_DI,
    category: CATEGORIES.RESTAURANT_ACTION,
    scope: SCOPES.RESTAURANT,
    conditions: [CONDITIONS.SIDEBAR_FOCUSED_NO_INPUT],
    description: "Dine-In",
    gated: true,
    phase: 2,
  },
  {
    id: "key-1-de",
    label: "1",
    match: { keyCode: 49 },
    action: ACTIONS.FULFILLMENT_DE,
    category: CATEGORIES.RESTAURANT_ACTION,
    scope: SCOPES.RESTAURANT,
    conditions: [CONDITIONS.SIDEBAR_FOCUSED_NO_INPUT],
    description: "Delivery",
    gated: true,
    phase: 2,
  },
  {
    id: "key-2-ta",
    label: "2",
    match: { keyCode: 50 },
    action: ACTIONS.FULFILLMENT_TA,
    category: CATEGORIES.RESTAURANT_ACTION,
    scope: SCOPES.RESTAURANT,
    conditions: [CONDITIONS.SIDEBAR_FOCUSED_NO_INPUT],
    description: "Takeaway",
    gated: true,
    phase: 2,
  },
  {
    id: "alt-1-9-section",
    label: "Alt+1–9",
    match: { keyCode: [49, 50, 51, 52, 53, 54, 55, 56, 57], alt: true },
    action: ACTIONS.SWITCH_SECTION,
    category: CATEGORIES.RESTAURANT_ACTION,
    scope: SCOPES.RESTAURANT,
    conditions: [CONDITIONS.TABLE_VIEW],
    description: "Switch floor/section",
    gated: true,
    phase: 2,
  },
];

// ── Zone configurations per layout ─────────────────────────────────────

export const ZONE_IDS = {
  SEARCH: "search",
  CART: "cart",
  CUSTOMER: "customer",
  MENU_BUTTONS: "menuButtons",
  PAYMENT: "payment",
  SIDEBAR: "sidebar",
  TABLES: "tables",
  PRODUCTS: "products",
  ORDER_PANEL: "orderPanel",
  ORDER_ACTIONS: "orderActions",
};

const SM_ZONES = [
  {
    id: ZONE_IDS.SEARCH,
    fKeyCode: 113,
    fLabel: "F2",
    label: "Product Search",
    ariaRole: "search",
    ariaLabel: "Product search zone",
    innerKeys: [
      { label: "Enter", description: "Search" },
      { label: "Arrow Down", description: "Into results" },
      { label: "Tab", description: "Scan/Filter buttons" },
    ],
  },
  {
    id: ZONE_IDS.CART,
    fKeyCode: 114,
    fLabel: "F3",
    label: "Cart Table",
    ariaRole: "grid",
    ariaLabel: "Cart items",
    innerKeys: [
      { label: "Up/Down", description: "Navigate items" },
      { label: "+/−", description: "Adjust qty" },
      { label: "Delete", description: "Remove item" },
      { label: "Enter", description: "Edit details" },
      { label: "Space", description: "Toggle checkbox" },
    ],
  },
  {
    id: ZONE_IDS.CUSTOMER,
    fKeyCode: 115,
    fLabel: "F4",
    label: "Customer Bar",
    ariaRole: "region",
    ariaLabel: "Customer zone",
    innerKeys: [
      { label: "Tab", description: "Add/Edit/Search" },
    ],
  },
  {
    id: ZONE_IDS.MENU_BUTTONS,
    fKeyCode: 116,
    fLabel: "F5",
    label: "Menu Buttons",
    ariaRole: "menu",
    ariaLabel: "Cart menu",
    innerKeys: [
      { label: "Up/Down", description: "Navigate buttons" },
      { label: "Enter", description: "Activate" },
    ],
  },
  {
    id: ZONE_IDS.PAYMENT,
    fKeyCode: 117,
    fLabel: "F6",
    label: "Payment Bar",
    ariaRole: "toolbar",
    ariaLabel: "Payment methods",
    innerKeys: [
      { label: "Left/Right", description: "Cycle methods" },
      { label: "Enter", description: "Select method" },
      { label: "0–9 / .", description: "Enter amount" },
      { label: "Backspace", description: "Delete digit" },
    ],
  },
];

const RESTAURANT_ZONES = [
  {
    id: ZONE_IDS.SIDEBAR,
    fKeyCode: 113,
    fLabel: "F2",
    label: "Sidebar / Search",
    ariaRole: "navigation",
    ariaLabel: "Sidebar navigation",
    innerKeys: [
      { label: "Up/Down", description: "Navigate items" },
      { label: "Enter", description: "Activate" },
      { label: "0/1/2", description: "DI/DE/TA switch" },
    ],
  },
  {
    id: ZONE_IDS.TABLES,
    fKeyCode: 114,
    fLabel: "F3",
    label: "Tables / Categories",
    ariaRole: "grid",
    ariaLabel: "Table grid",
    innerKeys: [
      { label: "Arrows", description: "Navigate grid" },
      { label: "Enter", description: "Select table" },
      { label: "Home/End", description: "First/last table" },
    ],
  },
  {
    id: ZONE_IDS.PRODUCTS,
    fKeyCode: 115,
    fLabel: "F4",
    label: "Product Grid",
    ariaRole: "grid",
    ariaLabel: "Product grid",
    innerKeys: [
      { label: "Arrows", description: "Navigate products" },
      { label: "Enter", description: "Add to order" },
      { label: "1–9", description: "Set qty before adding" },
    ],
  },
  {
    id: ZONE_IDS.ORDER_PANEL,
    fKeyCode: 116,
    fLabel: "F5",
    label: "Order Panel",
    ariaRole: "grid",
    ariaLabel: "Order items",
    innerKeys: [
      { label: "Up/Down", description: "Navigate rows" },
      { label: "+/−", description: "Adjust qty" },
      { label: "Delete", description: "Remove item" },
    ],
  },
  {
    id: ZONE_IDS.ORDER_ACTIONS,
    fKeyCode: 117,
    fLabel: "F6",
    label: "Order Actions",
    ariaRole: "toolbar",
    ariaLabel: "Order actions",
    innerKeys: [
      { label: "Left/Right", description: "Navigate buttons" },
      { label: "Enter", description: "Activate" },
    ],
  },
];

export const ZONE_CONFIGS = {
  [SCOPES.SUPERMARKET]: SM_ZONES,
  [SCOPES.RESTAURANT]: RESTAURANT_ZONES,
};

// ── Matcher: does an event match a shortcut's match spec? ──────────────

function eventMatchesSpec(event, spec) {
  const wantAlt = spec.alt === true;
  const wantCtrl = spec.ctrl === true;
  const wantShift = spec.shift === true;
  if (event.altKey !== wantAlt) return false;
  if (event.ctrlKey !== wantCtrl) return false;
  if (event.shiftKey !== wantShift) return false;

  if (spec.keyCode != null) {
    const codes = Array.isArray(spec.keyCode) ? spec.keyCode : [spec.keyCode];
    if (!codes.includes(event.keyCode)) return false;
  }
  return true;
}

function shortcutMatchesScope(shortcut, layout) {
  return shortcut.scope === SCOPES.BOTH || shortcut.scope === layout;
}

/**
 * Find the first shortcut matching a keyboard event for the given layout.
 * Returns the shortcut entry or null.
 * Does NOT evaluate runtime conditions — caller must check those.
 */
export function findShortcut(event, layout, featureFlagEnabled) {
  for (let i = 0; i < shortcuts.length; i++) {
    const s = shortcuts[i];
    if (s.gated && !featureFlagEnabled) continue;
    if (!shortcutMatchesScope(s, layout)) continue;
    if (eventMatchesSpec(event, s.match)) return s;
  }
  return null;
}

/**
 * Find the zone that matches an F-key event.
 * Returns the zone config or null.
 */
export function findZoneByKeyCode(keyCode, layout) {
  const zones = ZONE_CONFIGS[layout];
  if (!zones) return null;
  return zones.find((z) => z.fKeyCode === keyCode) || null;
}

// ── Help overlay grouping ──────────────────────────────────────────────

export function getOverlayGroups(layout) {
  const zoneNav = [];
  const actions = [];
  const cartNav = [];
  const restaurantActions = [];

  for (const s of shortcuts) {
    if (!shortcutMatchesScope(s, layout)) continue;
    switch (s.category) {
      case CATEGORIES.ZONE_NAV:
        zoneNav.push({ label: s.label, description: s.description });
        break;
      case CATEGORIES.ACTION:
        actions.push({ label: s.label, description: s.description });
        break;
      case CATEGORIES.CART_NAV:
        cartNav.push({ label: s.label, description: s.description });
        break;
      case CATEGORIES.RESTAURANT_ACTION:
        restaurantActions.push({ label: s.label, description: s.description });
        break;
    }
  }

  const groups = [
    { title: "Zone Navigation", items: zoneNav },
    { title: "Actions", items: actions },
    { title: "Cart / Order", items: cartNav },
  ];
  if (restaurantActions.length > 0) {
    groups.push({ title: "Restaurant", items: restaurantActions });
  }

  const zones = ZONE_CONFIGS[layout] || [];
  if (zones.length > 0) {
    groups.push({
      title: "Within Active Zone",
      items: zones.flatMap((z) =>
        z.innerKeys.map((k) => ({
          label: k.label,
          description: `${z.label}: ${k.description}`,
        }))
      ),
    });
  }

  return groups;
}

export default shortcuts;
